import {useIntl} from 'react-intl'
import {useMember} from '../../hook'

// import Select from 'react-select';

export default function MemberDetailConsents() {
  const intl = useIntl()
  const {detailTab} = useMember()

  const content = detailTab?.Consent

  if (!content) return null

  // const yesNoOptions = [
  //   { value: false, label: intl.formatMessage({ id: 'NO' }) },
  //   { value: true, label: intl.formatMessage({ id: 'YES' }) },
  // ]

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS'})}
            </h3>
            <p className='text-muted fw-normal fs-6'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS_TOOLTIP'})}
            </p>
          </div>
          {/* <span className='position-relative'>
            <OverlayTrigger
              trigger='hover'
              placement='top'
              overlay={
                <Tooltip>
                  {intl.formatMessage({ id: 'MEMBER.DETAIL.CONSENTS_TOOLTIP' })}
                </Tooltip>
              }
            >
              <i className='bi bi-info-circle text-primary ms-1'></i>
            </OverlayTrigger>
          </span> */}
        </div>
      </div>

      <div className='card-body p-9'>
        <div className='row'>
          <div className='col-md-4 mb-4'>
            <label className='col-lg-4 fw-semibold text-muted'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS.GDPR'})}
            </label>

            <div className='col-lg-4 mt-2'>
              <span className='fw-semibold text-gray-800 fs-6'>
                {content.termsAndConditions
                  ? intl.formatMessage({id: 'YES'})
                  : intl.formatMessage({id: 'NO'})}
              </span>
              {/* <Select
                  className='custom-select'
                  options={yesNoOptions}
                  value={yesNoOptions.find((s) => s.value === content.gdpr)}
                /> */}
              {/* <select
                  className='form-select form-select-solid'
                  data-control='select2'
                  data-placeholder='Select an option'
                  data-hide-search='true'
                  value={content.gdpr ? 2 : 1}
                  onChange={() => {}}
                >
                  <option></option>
                  <option value='1'>{intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS.NO'})}</option>
                  <option value='2'>
                    {intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS.YES'})}
                  </option>
                </select> */}
            </div>
          </div>

          <div className='col-md-4 mb-4'>
            <label className='col-lg-4 fw-semibold text-muted'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS.EMAIL_MARKETING'})}
            </label>

            <div className='col-lg-4 fv-row mt-2'>
              <span className='fw-semibold text-gray-800 fs-6'>
                {content.email ? intl.formatMessage({id: 'YES'}) : intl.formatMessage({id: 'NO'})}
              </span>
            </div>
          </div>

          <div className='col-md-4 mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>
              {intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS.SMS_MARKETING'})}
            </label>

            <div className='col-lg-4 mt-2'>
              <span className='fw-semibold text-gray-800 fs-6'>
                {content.sms ? intl.formatMessage({id: 'YES'}) : intl.formatMessage({id: 'NO'})}
              </span>
            </div>
          </div>

          {/* <div className='col'>
          <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({ id: 'MEMBER.DETAIL.CONSENTS.MOBILE_PUSH' })}
              </label>

              <div className='col-lg-4 mt-2'>
                <span className='fw-semibold text-gray-800 fs-6'>{content.push ? intl.formatMessage({ id: 'YES' }) : intl.formatMessage({ id: 'NO' })}</span>
              </div>
            </div>
            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({ id: 'MEMBER.DETAIL.CONSENTS.CALL_CENTER' })}
              </label>

              <div className='col-lg-4 mt-2'>
                <span className='fw-semibold text-gray-800 fs-6'>{content.ivr ? intl.formatMessage({ id: 'YES' }) : intl.formatMessage({ id: 'NO' })}</span>
              </div>
            </div>

            <div className='column mb-7'>
              <label className='col-lg-4 fw-semibold text-muted'>
                {intl.formatMessage({ id: 'MEMBER.DETAIL.CONSENTS.IN_APP_MESSAGE' })}
              </label>

              <div className='col-lg-4 mt-2'>
                <span className='fw-semibold text-gray-800 fs-6'>{content.inApp ? intl.formatMessage({ id: 'YES' }) : intl.formatMessage({ id: 'NO' })}</span>
              </div>
            </div> 
          </div> */}
        </div>
      </div>
    </div>
  )
}
